import React from 'react';
import { titleMRClass } from "src/components/common/common";

/** 키오스크 화면 폼 제목 기본 스타일 (높이 38px 입력칸 줄 기준) */
export const KIOSK_FORM_TITLE_STYLE =
  "w-[120px] min-w-[120px] h-[38px] flex items-center rounded-[8px] bg-[#e8eff8] px-[10px] text-left text-[14px] font-semibold leading-none whitespace-nowrap text-[#183153]";

interface KioskFormTitleProps {
  // 표시 문구. 데이터·이벤트는 받지 않는다 (입력칸은 화면에서 처리).
  title: string;
  // 있으면 width/minWidth를 인라인으로 적용한다. 없으면 상수의 w-[120px]를 사용한다.
  titleWidth?: number;
}

export const KioskFormTitle: React.FC<KioskFormTitleProps> = ({
  title,
  titleWidth,
}) => {
  return (
    <span
      className={`form-title ${titleMRClass} ${KIOSK_FORM_TITLE_STYLE}`}
      style={titleWidth ? { width: titleWidth, minWidth: titleWidth } : undefined}
    >
      {title}
    </span>
  );
};
